import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import PrimaryButton from "../../../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../../../Buttons/SecondaryButton/SecondaryButton";
import TertiaryButton from "../../../../../Buttons/TertiaryButton/TertiaryButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import StagedComchecksTable from "../StagedComchecksTable/StagedComchecksTable";
import { formatCurrency } from "../../../../../../utils/formatHelpers";
import { handleAltEnter } from "../../../../../../utils/keyboardShortcutHelpers";

export default function ComchecksStepTwo({ 
  activeLoad,
  comcheckToReview, 
  stagedComchecksArray, 
  setStep, 
  setComcheckToEdit,
  setComcheckToReview,
  handleCancel,
  handleDeleteStagedComcheck
}) {

  const {
    bolNumber,
    carrierName,
    comcheckFee,
    comcheckType,
    driverName,
    totalAmount,
    maxAllowed,
    requestedAmount,
    sealNumber,
    tractorNumber,
    trailerNumber,
    carrierLinehaul,
    totalFsc,
    accessorial
  } = comcheckToReview;

  const handleEdit = () => {
    setComcheckToEdit(comcheckToReview);
    setComcheckToReview({});
    setStep(1);
  };

  const handleAddNew = () => {
    setComcheckToEdit({});
    setStep(1);
  };
 
  const handleSubmit = () => {
    setStep(4);
  };

  const handleReviewAll = () => {
    setStep(3);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      handleAltEnter(e, false, stagedComchecksArray.length === 1 ? handleSubmit : handleReviewAll);
    };

    document.addEventListener("keydown", handleKeyDown);

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
 
  return (
    <Box>
      <Box className="Accessorial-modal-form-row">
        <Typography variant="subhead2" color="black_solid.60">
          Verify the Carrier
        </Typography>
        <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
          {carrierName}
        </Typography>
      </Box> 
      <Box className="Accessorial-modal-form-row" sx={{ display: "flex" }}>
        <Box>
          <Typography variant="subhead2" color="black_solid.60">
            Tractor / Trailer
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {tractorNumber} / {trailerNumber}
          </Typography>
        </Box>
        <Box sx={{marginLeft: "80px"}}>
          <Typography variant="subhead2" color="black_solid.60">
            Line Haul
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {formatCurrency(carrierLinehaul, 2)}
          </Typography>
        </Box>
        <Box sx={{marginLeft: "80px"}}>
          <Typography variant="subhead2" color="black_solid.60">
            Fuel Surcharge
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {formatCurrency(totalFsc, 2)}
          </Typography>
        </Box>
      </Box>
      <Box className="Accessorial-modal-form-row" sx={{ display: "flex" }}>
        <Box>
          <Typography variant="subhead2" color="black_solid.60">
            Comcheck Reason
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {comcheckType}
          </Typography>
        </Box>
        {comcheckType === "Accessorial" &&
        <Box sx={{ marginLeft: "40px" }}>
          <Typography variant="subhead2" color="black_solid.60" >
            Accessorial
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {accessorial.shortDescription}
          </Typography>
        </Box>
        }
      </Box>   
      <Box className="Accessorial-modal-form-row">
        <Box>
          <Typography variant="subhead2" color="black_solid.60">
            Driver Name
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {driverName}
          </Typography>
        </Box>
      </Box>
      <Box className="Accessorial-modal-form-row" sx={{ display: "flex" }}>
        <Box>
          <Typography variant="subhead2" color="black_solid.60">
            Seal Number
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {sealNumber}
          </Typography>
        </Box>
        <Box sx={{ marginLeft: "78px" }}>
          <Typography variant="subhead2" color="black_solid.60" >
            BOL Number
          </Typography>
          <Typography variant="subhead1" color="black_solid.80" sx={{ margin: "6px 0 0 4px" }}>
            {bolNumber}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ backgroundColor: "black_solid.50" }}/>
      <Box className="Accessorial-modal-form-row" sx={{ display: "flex" }}>
        <Box>
          <Typography variant="subhead2" color="black_solid.60">
            Requested Amount
          </Typography>
          <Typography variant="h2" color="black_solid.80" sx={{ marginTop: "6px"}}>
            {formatCurrency(requestedAmount, 2)}
          </Typography>
        </Box>
        <Box sx={{ marginLeft: "30px" }}>
          <Typography variant="subhead2" color="black_solid.60" >
            Comcheck Fee
          </Typography>
          <Typography variant="h2" color="black_solid.80" sx={{ marginTop: "6px"}}>
            {formatCurrency(comcheckFee, 2)}
          </Typography>
        </Box>
        <Box sx={{ marginLeft: "30px" }}>
          <Typography variant="subhead2" color="black_solid.60">
            {`${comcheckType} Total`}
          </Typography>
          <Typography variant="h2" color="black_solid.80" sx={{ marginTop: "6px"}}>
            {formatCurrency(totalAmount, 2)}
          </Typography>
        </Box>
        <Box sx={{ marginLeft: "30px" }}>
          <Typography variant="subhead2" color="black_solid.60" >
            Max Allowed
          </Typography>
          <Typography variant="h2" color="black_solid.80" sx={{ marginTop: "6px"}}>
            {formatCurrency(maxAllowed, 2)}
          </Typography>
        </Box>
      </Box>
      {stagedComchecksArray.length > 1 && 
        <Box sx={{ margin: "30px 0" }}>
          <StagedComchecksTable 
            activeLoad={activeLoad} 
            stagedComchecksArray={stagedComchecksArray}
            setComcheckToEdit={setComcheckToEdit}
            comcheckIdUnderReview={comcheckToReview.tempId}
            setStep={setStep}
            handleDeleteStagedComcheck={handleDeleteStagedComcheck}
          />
        </Box>
      } 
      <Box sx={{ display: "flex", marginTop: "50px" }}>
        <Box sx={{ marginLeft: "auto" }}>
          <TertiaryButton 
            label="Add Comcheck"
            onClick={handleAddNew}
            startIcon={AddCircleIcon}
          />
        </Box>
      </Box>
      <Box sx={{ display: "flex", marginTop: "30px" }}>
        <Box sx={{ margin: "0 30px 0 auto"}}>
          <SecondaryButton
            id="cancel-button"
            label="Cancel"
            onClick={handleCancel}
          />
        </Box>
        <Box sx={{ marginRight: "30px" }}>
          <SecondaryButton
            id="edit-button"
            label="Edit"
            onClick={handleEdit}
          />
        </Box>
        {stagedComchecksArray.length === 1 ? (
          <Box>
            <PrimaryButton
              id="submit-button"
              label="Submit"
              onClick={handleSubmit}
            />
          </Box>
        ) : (
          <Box>
            <PrimaryButton
              id="review-all-button"
              label="Review All"
              onClick={handleReviewAll}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

ComchecksStepTwo.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  comcheckToReview: PropTypes.object.isRequired,
  stagedComchecksArray: PropTypes.array.isRequired,
  setStep: PropTypes.func.isRequired,
  setComcheckToEdit: PropTypes.func.isRequired,
  setComcheckToReview: PropTypes.func,
  handleCancel: PropTypes.func.isRequired,
  handleDeleteStagedComcheck: PropTypes.func
};